import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/[locale]/blog/_component/BlogDateTime.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/assets/images/blog-page/blog-empty.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/features/src/shared/contentful-rich-text/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.4_next@15.5.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__re_6f60c95aa2d12de4b02cd8de65b868ef/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@3.26.4_next@15.5.0_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__re_6f60c95aa2d12de4b02cd8de65b868ef/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.0_@babel+core@7.28.3_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react_5a64d2da76b76471fdacb3f4f700c114/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-facebook.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-instagram.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-linkedin.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-telegram.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-x.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/assets/svgs/social/ic-youtube.svg");
